export const P0003607SensContactSelEnum = [
  { ref: 0, label: 'P0003607.senscontactsel.0' },
  { ref: 1, label: 'P0003607.senscontactsel.1' },
];
